module.exports = __webpack_public_path__ + "static/media/noun_Save_2433479.7003fc07.svg";